module.exports = __webpack_public_path__ + "static/media/exclamation-mark.3ebdf7ff.svg";